import { Link } from 'react-router-dom';
import { useCart } from '../hooks/useCart';

export const CartIcon = () => {
  const { cartCount } = useCart();

  return (
    <Link to="/cart" className="relative flex items-center justify-center w-10 h-10 hover:bg-gray-100 rounded-full transition-colors cursor-pointer">
      <i className="ri-shopping-cart-line text-xl"></i>
      {cartCount > 0 && (
        <span className="absolute -top-1 -right-1 bg-coral-500 text-white text-xs font-semibold rounded-full w-5 h-5 flex items-center justify-center">
          {cartCount}
        </span>
      )}
    </Link>
  );
};
